const AUTO_RELOAD_KEY = 'systemUnavailableAutoReloadAt';
const AUTO_RELOAD_MIN_INTERVAL_MS = 2 * 60 * 1000;

export const reloadPage = () => {
  window.location.reload();
};

/**
 * Guard against reload loops - allow at most one automatic reload per interval.
 * Returns false when the page was already reloaded automatically recently.
 */
export const tryAutoReload = (): boolean => {
  const lastReloadAt = Number(sessionStorage.getItem(AUTO_RELOAD_KEY));
  if (Date.now() - lastReloadAt < AUTO_RELOAD_MIN_INTERVAL_MS) {
    return false;
  }
  sessionStorage.setItem(AUTO_RELOAD_KEY, String(Date.now()));
  reloadPage();
  return true;
};
